import { Switch, SwitchProps } from '@mui/material';
import React, { FC } from 'react';

/**
 * the properties which describe how the CfSwitch component should present and behave
 */
export interface CfSwitchProps {
  isChecked?: boolean;
  onChange?: (checked: boolean) => void;
  switchProps?: SwitchProps;
  'data-testid'?: string;
}

/**
 * Utilizes the MUI Switch component
 * @param checked passed to the Switch component's checked property
 * @param onChange passed to the Switch component's onChange property
 * @param switchProps passed to the Switch component's properties
 * @returns
 */
export const CfSwitch: FC<CfSwitchProps> = (props: CfSwitchProps) => {
  const { isChecked, onChange, switchProps } = props;
  return (
    <Switch
      {...switchProps}
      checked={isChecked}
      onChange={(_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
        onChange?.(checked);
      }}
      onKeyDown={(event) => {
        if (event.key === 'Enter') {
          const newValue = !(isChecked ?? false);
          onChange?.(newValue);
        }
      }}
      data-testid={props['data-testid']}
    />
  );
};
